import { State } from '@omniafishing/core';

export const getStateBySlug = (states: State[], slug: string) => {
  return states.filter((s) => s.slug === slug)[0];
};
